module.exports = __webpack_public_path__ + "fonts/Rubik-300-cyrillic-ext59.f2f7a74.woff2";